import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";

class IdentitySystemSettingService extends IdentityService {
    public getByCondition = async (data: {
        settingCode: string,
        serviceCode?: string,
        tenantCode?: string,
        organizationId?: string,
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({ path: `${Constants.ApiPath.IDENTITY_SYSTEM_SETTING.GET_BY_CONDITION}?${query}` });
        return result.data.result;
    };
}

export default IdentitySystemSettingService;
